import { ReactNodeViewRenderer } from "@tiptap/react"

import { BaseAttachmentNode } from "../BaseAttachment/extension"
import { IssueAttachmentNodeComponent } from "./Component"

export const IssueAttachmentNode = BaseAttachmentNode.extend({
	addNodeView() {
		return ReactNodeViewRenderer(IssueAttachmentNodeComponent)
	},
})
